import React from "react";
import { useContext, useEffect, useRef, useState } from "react";
import noImage from "../assets/images/settings/no-image.png";
import axios from "axios";
import { serverInfo } from "../App";

const ProfileInfo = () => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [user, setUser] = useState([]);
  const [profileImage, setProfileImage] = useState("");

  useEffect(() => {
    localStorage.getItem("auth_token") &&
      axios.get(`/api/user_info`).then((res) => {
        if (res.status === 200) {
          setUser(res.data.users);

          setProfileImage(
            res.data.users.image !== null
              ? imageCdnUrl + res.data.users.image
              : noImage
          );
        }
      });
  }, []);
  return (
    <>
      <div className="bg-star-nav d-flex justify-content-center align-items-center py-3">
        <div className="div">
          <img
            src={profileImage ? profileImage : noImage}
            alt=""
            className="profile-img-src p-1"
          />
        </div>
      </div>
      <div className="d-flex justify-content-center pt-1">
        <span className="UserName-a fw-bold">
          {user.first_name} {user.last_name}
        </span>
        <br />
      </div>

      <h6 className="userName text-center ">
        {user.username != null ? (
          <>@{user.username ? user.username : null}</>
        ) : null}
      </h6>

      <div className="underPro mb-2"></div>
    </>
  );
};

export default ProfileInfo;
